export default __webpack_public_path__ + "static/media/img_company_header35.76a52926.png";